import React, { FunctionComponent } from 'react';

import cn from 'classnames';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../../init-store';
import css from './index.css';

const NUMBER_OF_BACKGROUNDS = 20;

export const BACKGROUNDS: Array<string> = [];
for (let i = 1; i <= NUMBER_OF_BACKGROUNDS; i++) {
    BACKGROUNDS[i] = require(`./images/${i}.jpg`);
}

const overlayColors = [
    'rgba(0, 0, 0, 0.1)',
    'rgba(15, 9, 23, 0.1)',
    'rgba(0, 0, 0, 0.2)',
    'rgba(0, 0, 0, 0.1)',
    'rgba(2, 5, 8, 0.1)',
    'rgba(15, 9, 23, 0.4)',
    'rgba(11, 7, 20, 0.3)',
    'rgba(9, 11, 23, 0.4)',
    'rgba(2, 11, 56, 0.25)',
    'rgba(0, 0, 0, 0.05)',
    'rgba(35, 46, 17, 0.4)',
    'rgba(6, 0, 43, 0.3)',
    'rgba(15, 9, 23, 0.25)',
    'rgba(41, 69, 4, 0.3)',
    'rgba(49, 17, 36, 0.4)',
    'rgba(19, 13, 46, 0.4)',
    'rgba(22, 24, 66, 0.4)',
    'rgba(18, 19, 10, 0.3)',
    'rgba(20, 7, 9, 0.4)',
    'rgba(0, 39, 66, 0.33)',
];

const connector = connect(({ config: { background } }: RootState) => ({ background }));

type Props = ConnectedProps<typeof connector> & {
    isAbsolute?: boolean;
};

const Background: FunctionComponent<Props> = ({ background, isAbsolute }) => {
    return (
        <div
            className={cn(css.BackgroundImage, 'BackgroundImage', { [css.BackgroundImage_absolute]: isAbsolute })}
            style={{ backgroundImage: `url(${BACKGROUNDS[background]})` }}
        >
            <div className={css.BackgroundOverlay} style={{ background: overlayColors[background - 1] }} />
        </div>
    );
};

export default connector(Background);
